import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import VehicleDrawer from "components/drawer/VehicleDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
// import ViewModal from "components/modal/ViewModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import RemarkModal from "components/modal/RemarkModal";
// internal imports

const RequestQueueTable = ({ vehicle ,perpage, currentPage}) => {
  const { title, serviceId,serviceBlock,  handleView } = useToggleDrawer();
  return (
    <>
    <RemarkModal id_data={serviceId} block_data={serviceBlock} title_data={title}></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      {/* <ViewModal id={serviceId} title={title} data={vehicle}/> */}

      <MainDrawer>
        <VehicleDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
      {vehicle?.slice(0, perpage).map((data,index) => (
          <TableRow key={data.id}>
            <TableCell>
              <span className="font-semibold uppercase text-xs">
               
                {((currentPage-1) * perpage)+index+1}
              </span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.vendor_name}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.city}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.vehicle_type_name}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.vehicle_reg_no}</span>
            </TableCell>  
            <TableCell>
              <span className="text-sm">{data.year_of_vehicle_manufactured}</span>
            </TableCell>            
           
            <TableCell>
              <span className="text-sm">{data.year_of_vehicle_manufactured}</span>
            </TableCell>  
            <TableCell>
              <div className="flex justify-end text-right">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                <button
                    onClick={() => handleView(data.id,'Vehicle Details')}
                    className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none">
                </button>
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default RequestQueueTable;
